export default __webpack_public_path__ + "static/media/objetivos.a7fe50d6.png";